const columnsFormat = [
    { id: 'K1', label: 'Date', minWidth: 120, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#0b88fe"}}>{value}</p>,  },
    { id: 'K4', label: 'Customer Name', minWidth: 120, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K6', label: 'Stock Item', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K9', label: 'Godown', minWidth: 80, align: 'left', format: (value) => <p style={{width: "10rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K10', label: 'Quantity', minWidth: 120, align: 'center', format: (value) => <p style={{width: "2rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K11', label: 'Total', minWidth: 120, align: 'left', format: (value) => <p style={{width: "5rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'Exchange', label: 'Exchange Value', minWidth: 120, align: 'left', format: (value) => <p style={{width: "5rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K12', label: 'Finance Name', minWidth: 120, align: 'left', format: (value) => <p style={{textAlign: "left", width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K8', label: 'IMEI Number', minWidth: 200, align: 'left', format: (value) => <p style={{width: "9rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#0b88fe"}}>{value}</p>, },
    { id: 'K13', label: 'Brand', minWidth: 120, align: 'left', format: (value) => <p style={{textAlign: "left", width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K14', label: 'Salesman', minWidth: 120, align: 'left', format: (value) => <p style={{width: "10rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K2', label: 'VCH Type', minWidth: 120, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>,  },
    { id: 'K3', label: 'Invoice Number', minWidth: 120, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#0b88fe"}}>{value}</p>, },
    { id: 'K5', label: 'Contact', minWidth: 120, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K7', label: 'Stock Group', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K15', label: 'Category', minWidth: 200, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    { id: 'K16', label: 'Stock Alias', minWidth: 200, align: 'left', format: (value) => <p style={{width: "8rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    // { id: 'K17', label: 'File Name', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    // { id: 'K18', label: 'DOB', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    // { id: 'K19', label: 'PDF File Name', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    // { id: 'id', label: 'Id', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#393939"}}>{value}</p>, },
    // Below should be a direct download link, if invoice is present, else show "No Invoice" in red color. user must not see the link in any case.
    // { id: 'invoice', label: 'Invoice', minWidth: 200, align: 'left', format: (value) => <p style={{width: "12rem",fontWeight: 500, color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#0b88fe"}}>{typeof value === "string" && value.toLowerCase() === "no" ? "No Invoice" : <a href={value} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: '#0b88fe'}}>Download Invoice</a>}</p>, },
    {
      id: 'invoice',
      label: 'Invoice',
      minWidth: 200,
      align: 'left',
      format: (value) => {
        const handleDownload = async (e) => {
          e.preventDefault();
          try {
            // Replace HTTPS with HTTP to avoid SSL certificate issues
            const httpUrl = value.replace('https://', 'http://');

            // Use fetch with mode: 'no-cors' to bypass CORS restrictions
            // However, 'no-cors' doesn't allow reading the response, so we use a different approach
            // Instead, we'll create a proxy request or use the URL directly in an iframe

            // Method 1: Try direct download using anchor tag (works if server allows it)
            const link = document.createElement('a');
            link.href = httpUrl;
            link.download = `invoice_${Date.now()}.pdf`;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';

            // Attempt to download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Method 2: Fallback - try fetch if CORS is properly configured
            // This will only work if the server has proper CORS headers
            // If it fails, the direct link method above will still open the file
            try {
              const response = await fetch(httpUrl, {
                mode: 'cors',
                credentials: 'omit'
              });

              if (response.ok) {
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const downloadLink = document.createElement('a');
                downloadLink.href = blobUrl;
                downloadLink.download = `invoice_${Date.now()}.pdf`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(blobUrl);
              }
            } catch (fetchError) {
              // If fetch fails, the direct link method will still work
              console.log('Fetch failed, using direct link method:', fetchError);
            }

          } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download invoice. Please try again or contact support.');
          }
        };

        return (
          <p style={{
            width: "12rem",
            fontWeight: 500,
            color: typeof value === "string" && value.toLowerCase() === "no" ? "#ff4646" : "#0b88fe"
          }}>
            {typeof value === "string" && value.toLowerCase() === "no" ? (
              "No Invoice"
            ) : (
              <span
                onClick={handleDownload}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#0b88fe'
                }}
              >
                Download Invoice
              </span>
            )}
          </p>
        );
      }
    }
  ];

  export default columnsFormat;